import React from 'react';
export function WaydevLogo({
  className = 'h-8',
  inverted = false
}: {
  className?: string;
  inverted?: boolean;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/nrG9gcEs6tFM5V2CNaZK1Z/pasted-image.png" alt="Waydev" className={`${className} w-auto object-contain ${inverted ? 'invert' : ''}`} data-id="element-341" />;
}